import React, {useContext, useEffect, useState} from 'react';

import {useNavigate, useParams} from "react-router-dom";
import {client, baseUrl} from "@/client"
import {bearerToken, emptyUser, GlobalContext} from "@/auth";
// React Icons https://react-icons.github.io/react-icons/icons?name=md
import {
    MdEditSquare,
    MdOutlineWindow,
    MdMenuBook,
    MdOutlineClose,
    MdOndemandVideo,
    MdArrowOutward,
    MdArrowCircleUp,
    MdKeyboardArrowDown,
    MdExpandLess,
    MdKeyboardArrowUp,
    MdOutlineAdd,
    MdRemove,
} from "react-icons/md";

import {
    ExPage,
    ExTabList,
} from "@/components/layout"

import {
    Tab,
    TabPanel,
    TabPanels,
    HStack,
    Button,
    Box,
    Flex,
    Text,
    AspectRatio,
    useDisclosure,
    Collapse,
    IconButton,
} from "@chakra-ui/react"

import { Rnd } from "react-rnd";

const scratchUrl = process.env.REACT_APP_SCRATCH_URL ?? window.location.origin + "/scratch_app/index.html";

//console.log("7525a94", scratchUrl)

// const WrappedGui = AppStateHOC(GUI)

// export class Scratch extends React.Component {
export const Scratch = (props) => {
    const navigate = useNavigate();
    const {globalState, setGlobalState} = useContext(GlobalContext);
    const [courseware, setCourseware] = useState(null);
    const params = useParams();
    const [canSaveParam, setCanSaveParam] = useState((props.canSave === false)? "&canSave=false": "&canSave=true");
    const [documentURL, setDocumentURL] = useState("");
    const [documentLoad, setDocumentLoad] = useState(false)
    const [documentVisible, setDocumentVisible] = useState(false)
    const [documentExpand, setDocumentExpand] = useState(true)
    const [documentPos, setDocumentPos] = useState({ x: 100, y: 50 });
    const [documentSize, setDocumentSize] = useState({ width: 800, height: 600 });


    const [movieURL, setMovieURL] = useState("");
    const [movieLoad, setMovieLoad] = useState(false)
    const [movieVisible, setMovieVisible] = useState(false)
    const [movieExpand, setMovieExpand] = useState(true)
    const [moviePos, setMoviePos] = useState({ x: 100, y: 50 });
    const [movieSize, setMovieSize] = useState({ width: 800, height: 600 });

    //const [butPosition, setButPosition] = useState({ x: 0, y: 50 })


    const { isOpen: isHEADOpen, onOpen: onHEADOpen, onClose: onHEADClose, onToggle:onHEADToggle } = useDisclosure({ defaultIsOpen: true })

    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0
    //const isTouchDevice = true

    useEffect(() => {
        (async () => {
            const resp = await client.getCoursewareByProject({
                bearerToken: bearerToken(),
                projectId: params.pid,
            })
            setGlobalState({...globalState, currentUser: resp.currentUser ?? emptyUser()})
            setCourseware(resp.courseware ?? null)
            console.log(resp.courseware)

            if ((resp.courseware) && ((resp.courseware.permission & 1024) > 0)) {
                setCanSaveParam("&canSave=false")
            }

            if (resp.courseware.documentId) {
                setDocumentURL(baseUrl + "/scratch_api/assets/" + resp.courseware.documentId)
            }

            if (resp.courseware.movieId) {
                setMovieURL(baseUrl + "/scratch_api/assets/" + resp.courseware.movieId)
            }

            //console.log(`84299dc: ${JSON.stringify(resp)}`)

            if (! resp.currentUser) {
                navigate('/');
            }

            //console.log(`84299dc: ${JSON.stringify(resp)}`)
        })();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    /*
    useEffect(() => {
        updatePosition()
        window.addEventListener("resize", updatePosition)
        return () => window.removeEventListener("resize", updatePosition)
      }, [])

    const updatePosition = () => {
        const x = window.innerWidth - 100
        setButPosition({ x, y: 50 })
      }
        */


    const onDocumentOpen = () => {
        if (!documentVisible) {
            if (!documentLoad) {
                setDocumentLoad(true)
            }

            var width = window.innerWidth*0.6
            var height = width*0.75
            var px = window.innerWidth * 0.15
            var py = (window.innerHeight - height) * 0.5
            if (py < 0) {
                py = 0
            }
            setDocumentPos({ x: px, y: py })
            setDocumentSize({ width: width, height: height })
            setDocumentVisible(true)
        }
    }

    const onDocumentExpand = () => {
        var newwidth = documentSize.width + window.innerWidth*0.05
        if (newwidth > window.innerWidth) {
            newwidth = window.innerWidth
        }
        var newheight = newwidth*0.75
        if (newheight > window.innerHeight) {
            newheight = window.innerHeight
        }
        setDocumentSize({ width: newwidth, height: newheight })
    }

    const onDocumentReduction = () => {
        var newwidth = documentSize.width - window.innerWidth*0.05
        if (newwidth < 400) {
            newwidth = 400
        }
        var newheight = newwidth*0.75
        if (newheight < 280) {
            newheight = 280
        }
        setDocumentSize({ width: newwidth, height: newheight })
    }

    const onMovieOpen = () => {
        if (!movieVisible) {
            if (!movieLoad) {
                setMovieLoad(true)
            }

            var width = window.innerWidth*0.6
            var height = width*0.75
            var px = window.innerWidth * 0.15
            var py = (window.innerHeight - height) * 0.5
            if (py < 0) {
                py = 0
            }
            setMoviePos({ x: px, y: py })
            setMovieSize({ width: width, height: height })
            setMovieVisible(true)
        }
    }

    const onMovieExpand = () => {
        var newwidth = movieSize.width + window.innerWidth*0.05
        if (newwidth > window.innerWidth) {
            newwidth = window.innerWidth
        }
        var newheight = newwidth*0.75
        if (newheight > window.innerHeight) {
            newheight = window.innerHeight
        }
        setMovieSize({ width: newwidth, height: newheight })
    }

    const onMovieReduction = () => {
        var newwidth = movieSize.width - window.innerWidth*0.05
        if (newwidth < 400) {
            newwidth = 400
        }
        var newheight = newwidth*0.75
        if (newheight < 280) {
            newheight = 280
        }
        setMovieSize({ width: newwidth, height: newheight })
    }


    const onMovieClose = () => {
        setMovieVisible(false)
        setMovieLoad(false)
    }

    //console.log(documentURL)
    //console.log(courseware)

    return <ExPage title={"うさプロ"}>
    
        <Collapse in={isHEADOpen} animateOpacity>
            <ExTabList onClick={() => {onHEADClose()}}>
                <HStack padding={1}>
                    {/* <Button isDisabled={window.history.length <= 2} onClick={() => {navigate(-1)}}>とじる</Button> */}
                    <Button isDisabled={window.history.length <= 2} onClick={() => {navigate("..", {relative: "path"})}}>とじる</Button>
                </HStack>
                <Tab _selected={{ color: "#ffffff", bg: "#855CD6" }}><MdEditSquare/>&nbsp;スクラッチ</Tab>
                {/* <Tab><MdArticle/>&nbsp;Document</Tab> */}
                {/*<Tab><MdPlayCircle/>&nbsp;Player</Tab>*/}
                <HStack padding={1}>
                    {isTouchDevice ? (
                        <>
                        {documentURL && (
                            <Button leftIcon={<MdArrowOutward />} onClick={() => {
                               window.open(`${documentURL}`, "_blank")
                            }}>きょうかしょ</Button>)}
                        {movieURL && (<Button leftIcon={<MdOndemandVideo />} onClick={onMovieOpen}>どうが</Button>)}
                        {/*
                        {movieURL &&
                            <Button leftIcon={<MdOndemandVideo />} onClick={() => {
                                window.open(`${movieURL}`, "_blank")
                            }}>どうが</Button>}
                        */}
                        </>
                   ) : (
                        <>
                    {documentURL && (<Button leftIcon={<MdMenuBook />} onClick={onDocumentOpen}>きょうかしょ</Button>)}
                        {movieURL && (<Button leftIcon={<MdOndemandVideo />} onClick={onMovieOpen}>どうが</Button>)}
                        </>
                    )}
                </HStack>
            </ExTabList>
        </Collapse>

        {!isHEADOpen && (
            <IconButton
                onClick={onHEADOpen}
                icon={<MdKeyboardArrowDown />}
                aria-label="ヘッダーをひょうじ"
                position="fixed"
                top="9px"
                right="8px"
                zIndex={1000}
                isRound
                size="sm"
                boxShadow="md"
                w="30px"
                h="30px"
            />
        )}

        <TabPanels flex="1" overflow="auto" height={"100%"}>
            <TabPanel padding={0} height={"100%"}>
                <iframe src={scratchUrl + `?projectId=${params.pid ?? 1}&projectToken=${bearerToken()}&${canSaveParam}`} style={{border: "none", width: "100%", height: "100%"}}></iframe>
            </TabPanel>
        </TabPanels>

        {!isTouchDevice && documentLoad && (
            <Rnd
                default={{
                    x: 0,
                    y: 0,
                    width: 800,
                    height: 600,
                }}
                position={documentPos}
                onDragStop={(e, d) => {
                    setDocumentPos({ x: d.x, y: d.y }); // ドラッグ後の位置を保存
                }}
                size={documentExpand ? documentSize : { width: documentSize.width, height: 64 }}
                bounds="window"
                disableUserSelectHack={true}
                resizeGrid={[2, 2]}
                style={{
                    position: "fixed",
                    zIndex: 1000, // モーダルっぽく重ねる
                    display: documentVisible ? "block" : "none", // ← ここで非表示制御
                }}
            >
                <Box
                    bg="white"
                    boxShadow="xl"
                    h="100%"
                    display="flex"
                    flexDirection="column"
                    border="4px solid #df6694" // ← これを追加！
                    //border="3px solid #855cd6" // ← これを追加！
                >
                    <Flex
                        bg="white"
                        p={3}
                        borderTopRadius="md"
                        cursor="move"
                        fontWeight="bold"
                        align="center"
                        justify="space-between" // ← 左右に配置
                    >
                        <Box>きょうかしょ</Box>
                        <Box>
                            <IconButton
                                onClick={() => onDocumentReduction()}
                                icon={<MdRemove />}
                                aria-label={"きょうかしょをちいさくする"}
                                zIndex={1000}
                                isRound
                                size="sm"
                                marginRight={4}
                                />
                            <IconButton
                                onClick={() => onDocumentExpand()}
                                icon={<MdOutlineAdd />}
                                aria-label={"きょうかしょを大きくする"}
                                zIndex={1000}
                                isRound
                                size="sm"
                                marginRight={4}
                                />
                            <IconButton
                                onClick={() => setDocumentExpand(!documentExpand)}
                                icon={documentExpand ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                                aria-label={documentExpand ? "きょうかしょをかくす" : "きょうかしょをひらく"}
                                zIndex={1000}
                                isRound
                                size="sm"
                                marginRight={4}
                                />
                            <Button size="sm" leftIcon={<MdOutlineClose />} onClick={() => setDocumentVisible(false)}>とじる</Button>
                        </Box>
                    </Flex>
                    <Box flex="1" style={{ display: documentExpand ? "block" : "none" }} >
                        <iframe
                            src={`${documentURL}`}
                            width="100%"
                            height="100%"
                            style={{ border: "none" }}
                            title="きょうかしょ"
                        />
                    </Box>
                </Box>
            </Rnd>
        )}

        {/*
        {isTouchDevice && documentLoad && (
            <Box
                display={documentVisible ? "block" : "none"}
                position="fixed"
                top="10%"
                left="50%"
                transform="translateX(-50%)"
                width={{ base: "95%", md: "80%", lg: "60%" }}
                height="600px"
                bg="white"
                borderRadius="md"
                boxShadow="xl"
                zIndex={1000}
            >
                <Flex
                    bg="gray.100"
                    p={3}
                    borderTopRadius="md"
                    justify="space-between"
                    align="center"
                >
                    <Text fontWeight="bold">きょうかしょ</Text>
                    <Button size="sm" onClick={() => setDocumentVisible(false)}>とじる</Button>
                </Flex>
                <Box flex="1" h="calc(100% - 50px)">
                    <iframe
                        src={documentURL}
                        width="100%"
                        height="100%"
                        style={{ border: "none" }}
                        title="きょうかしょ"
                    />
                </Box>
            </Box>        
        )}
        */}

        {!isTouchDevice && movieLoad && (
            <Rnd
                default={{
                    x: 0,
                    y: 0,
                    width: 800,
                    height: 600,
                }}
                position={moviePos}
                onDragStop={(e, d) => {
                    setMoviePos({ x: d.x, y: d.y }); // ドラッグ後の位置を保存
                }}
                size={movieExpand ? movieSize : { width: movieSize.width, height: 64 }}
                bounds="window"
                disableUserSelectHack={true}
                resizeGrid={[2, 2]}
                style={{
                    position: "fixed",
                    zIndex: 1000, // モーダルっぽく重ねる
                    display: movieVisible ? "block" : "none", // ← ここで非表示制御
                }}
            >
                <Box
                    bg="white"
                    borderRadius="md"
                    boxShadow="xl"
                    h="100%"
                    display="flex"
                    flexDirection="column"
                    border="4px solid #df6694" // ← これを追加！
                >
                    <Flex
                        bg="white"
                        p={3}
                        borderTopRadius="md"
                        cursor="move"
                        fontWeight="bold"
                        align="center"
                        justify="space-between" // ← 左右に配置
                    >
                        <Box>どうが</Box>
                        <Box>
                            <IconButton
                                onClick={() => onMovieReduction()}
                                icon={<MdRemove />}
                                aria-label={"どうがをちいさくする"}
                                zIndex={1000}
                                isRound
                                size="sm"
                                marginRight={4}
                                />
                            <IconButton
                                onClick={() => onMovieExpand()}
                                icon={<MdOutlineAdd />}
                                aria-label={"どうがを大きくする"}
                                zIndex={1000}
                                isRound
                                size="sm"
                                marginRight={4}
                                />
                            <IconButton
                                onClick={() => setMovieExpand(!movieExpand)}
                                icon={movieExpand ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                                aria-label={movieExpand ? "どうがをかくす" : "どうがをひらく"}
                                zIndex={1000}
                                isRound
                                size="sm"
                                marginRight={4}
                                />
                            <Button size="sm" leftIcon={<MdOutlineClose />} onClick={onMovieClose}>とじる</Button>
                        </Box>
                    </Flex>
                
                    <Box flex="1" style={{ display: movieExpand ? "block" : "none" }} >
                        <iframe
                            src={`${movieURL}`}
                            width="100%"
                            height="100%"
                            style={{ border: "none" }}
                            title="どうが"
                        />
                    </Box>
                </Box>
            </Rnd>
        )}

        {isTouchDevice && movieVisible && (

            <Box
                display={movieVisible ? "block" : "none"}
                position="fixed"
                top="10%"
                left="50%"
                transform="translateX(-50%)"
                width={{ base: "95%", md: "800px" }}
                bg="white"
                borderRadius="md"
                boxShadow="xl"
                zIndex={1000}
            >
                {/* ヘッダー */}
                <Flex
                    bg="white"
                    p={3}
                    borderTopRadius="md"
                    justify="space-between"
                    align="center"
                >
                    <Text fontWeight="bold">どうが</Text>
                    <Button size="sm" leftIcon={<MdOutlineClose />}  onClick={onMovieClose}>とじる</Button>
                </Flex>
                {/* どうが 本体 */}
                <AspectRatio ratio={16 / 9} width="100%">
                    <iframe
                        src={`${movieURL}`}
                        width="100%"
                        height="100%"
                        style={{ border: "none" }}
                        title="どうが"
                    />
                </AspectRatio>
            </Box>        
        )}


    </ExPage>
};

// {/*<div style={{background: "#bbddff", height: "100%"}}>hello</div>*/}
// {/*<div style={{margin: 0, padding: 0, overflow: "hidden", width: "100%", height: "100vh"}}>*/}
// {/*</div>*/}

// export function render(appTarget) {
//     // GUI.setAppElement(appTarget);
//     // const backpackHostMatches = window.location.href.match(/[?&]backpack_host=([^&]*)&?/);
//     // const backpackHost = backpackHostMatches ? backpackHostMatches[1] : null;
//     const backpackHost = null
//
//     // if (process.env.NODE_ENV === 'production' && typeof window === 'object') {
//     //     // Warn before navigating away
//     //     window.onbeforeunload = () => true;
//     // }
//
//     ReactDOM.render(<WrappedGui
//         canEditTitle
//         backpackVisible
//         showComingSoon
//         backpackHost={backpackHost}
//         canSave={false}
//         onClickLogo={onClickLogo}>
//     </WrappedGui>, appTarget)
// }

export default Scratch;
